import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
function AcademicEntrance() {
  useEffect(() => {
    document.title =
      "Syllabus Term-1 -  St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Entrance</li>
          <li>Exam</li>
          <li>Syllabus</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12">
              <h1 className="fw-bold">Entrance Exam Syllabus</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold"> UKG</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ENTERNCE-class-ukg.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold">LKG</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ENTERNCE-class-lkg.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold">Class - I</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ENTERNCE-class-1.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold">Class - II</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ENTERNCE-class-2.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold">Class - III</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ENTERNCE-class-3.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold">Class - IV</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ENTERNCE-class-4.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold"> Class - V</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ENTERNCE-class-5.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold"> Class - VI</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ENTERNCE-class-6.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold"> Class - VII</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ENTERNCE-class-7.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold"> Class - VIII</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ENTERNCE-class-8.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card syllabus-card h-100 text-center">
                <div className="card-body">
                  <div className="pdf-icon mb-3">📄</div>
                  <h6 className="fw-semibold"> Class - IX</h6>
                  <a
                    href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ENTERNCE-class-9.pdf"
                    target="_blank"
                    className="click-text"
                  >
                    Click Here →
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AcademicEntrance;
